import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

import { Icon } from '@valk-nx/components/ui-icon-list/src/lib/icon-list.interface';
import {
	EventDetailData,
	EventListData,
	RoomData,
} from '@valk-nx/storyblok-types/src/lib/types/content.interface';

export interface EventIconListOptions {
	dateFormat?: string;
	timeInputFormat?: string;
	timeOutputFormat?: string;
	translateFn?: (key: string) => string;
}

export function buildIconListRoom(room: RoomData): Icon[] {
	const iconList: Icon[] = [];
	const { facilities } = room;
	if (room.surfaceArea) {
		iconList.push({
			iconName: 'icon-surface-area',
			title: (room.surfaceArea / 10000).toString() + 'm²',
		});
	}
	if (facilities.sleepingComfort && facilities.sleepingComfort.length > 0) {
		iconList.push({
			iconName: 'icon-bed-double',
			title: facilities.sleepingComfort[0],
		});
	}
	if (facilities.bathroom && facilities.bathroom.length > 0) {
		iconList.push({
			iconName: 'icon-shower-bath',
			title: facilities.bathroom[0],
		});
	}
	return iconList;
}

export function buildEventIconList(
	event: EventListData | EventDetailData,
	options: EventIconListOptions = {},
): Icon[] {
	const {
		dateFormat = 'DD MMM YYYY',
		timeInputFormat = 'HH:mm:ss',
		timeOutputFormat = 'HH:mm',
		translateFn = (key: string) => key,
	} = options;

	const iconList: Icon[] = [];
	const { schedule } = event;

	if (schedule.startDate) {
		const prettyStartDate = dayjs(schedule.startDate).format(dateFormat);
		if (schedule.startDate === schedule.endDate) {
			iconList.push({
				iconName: 'icon-calendar',
				title: prettyStartDate,
			});
		} else {
			const prettyEndDate = dayjs(schedule.endDate).format(dateFormat);
			iconList.push({
				iconName: 'icon-calendar',
				title: `${prettyStartDate} - ${prettyEndDate}`,
			});
		}
		if (schedule.isRecurring) {
			iconList.push({
				iconName: 'icon-spinner',
				title: translateFn(
					'storyblok.pages.event-overview.recurring-event',
				),
			});
		}
		if (schedule.startTime) {
			const prettyStartTime = dayjs(
				schedule.startTime,
				timeInputFormat,
			).format(timeOutputFormat);
			if (schedule.endTime) {
				const prettyEndTime = dayjs(
					schedule.endTime,
					timeInputFormat,
				).format(timeOutputFormat);
				iconList.push({
					iconName: 'icon-clock',
					title: `${prettyStartTime} - ${prettyEndTime}`,
				});
			} else {
				iconList.push({
					iconName: 'icon-clock',
					title: prettyStartTime,
				});
			}
		}
	}

	return iconList;
}
